import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCreate = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "#444",
		transform: "scale(0.03125 0.03125)",
		children: /* @__PURE__ */ _jsx("path", { d: "M768 576h-192v192h-128v-192h-192v-128h192v-192h128v192h192v128z" })
	})
});
export default SvgCreate;
